module.exports = __webpack_public_path__ + "img/icon1.3ab859e.png";